export default __webpack_public_path__ + "static/media/erp_connection.91d33e4a.jpg";